module.exports = __webpack_public_path__ + "static/media/i-inka-icon_2-1.d6163844.svg";